import { type UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/provider';

import { expVal } from '@confluence/feature-experiments';
import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient.ts';
import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
	spaceContextOnly = false,
}) => {
	const options: UsePreFilteredExtensionsQueryOptions = {
		client: expVal('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false)
			? getApolloClient()
			: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context:
			spaceContextOnly && expVal('confluence_fix_space_apps_flickering', 'isEnabled', false)
				? { spaceKey }
				: { spaceKey, contentId },
		includeHidden,
	};

	return options;
};
